module.exports = __webpack_public_path__ + "img/002-car.6c81354f.svg";